import { localStorageSave, localStorageLoad } from '../services/localStorage';

// localstorage base key
const lstorBaseKey = 'auth';

const defaultProps = [
  'firstName',
  'lastName',
  'profilePicture',
  'token',
  'linkedInId',
]

const isLogged = function () {
  return !!this.token;
}

const doLogout = function () {
  defaultProps.forEach(elem => {
    this[elem] = '';
  });
  this.save();
}

const save = function () {
  const data = {}
  defaultProps.forEach(elem => {
    data[elem] = this[elem];
  });

  // const data = {
  //   firstName:this.firstName,
  //   lastName:this.lastName,
  //   profilePicture:this.profilePicture,
  //   token:this.token,
  //   linkedInId:this.linkedInId,
  // }
  const toSave = { [lstorBaseKey]: data }
  localStorageSave(toSave);
}

const getState = function () {
  const state = {}
  defaultProps.forEach(elem => {
    state[elem] = this[elem] || '';
  });
  return state;
}

export default (data) => {

  let retObj;

  const storage = localStorageLoad(lstorBaseKey) || {};
  if (data) {
    const merged = { ...storage, ...data }

    /*
      token,
      firstName,
      lastName,
      email,
      profilePicture,
      linkedInId
    */

    retObj = {
      firstName: merged.firstName,
      lastName: merged.lastName,
      profilePicture: merged.profilePicture,
      token: merged.token,
      linkedInId: merged.linkedInId,
      save
    }

    retObj.save();
  } else {
    retObj = storage;
    retObj.save = save;
  }

  retObj.isLogged = isLogged;
  retObj.getState = getState;
  retObj.doLogout = doLogout;

  return retObj;
}
